export const SET_CURRENCY = "SET_CURRENCY";
export const SET_CURRENCIES = "SET_CURRENCIES";
export const SET_BUSINESS_CURRENCIES = "SET_BUSINESS_CURRENCIES";
